import { MapEngine, EmbedHost } from "@trinitrotoluene/hexmap-map-engine";

/**
 * Embed entry point - runs inside the iframe.
 *
 * Initializes the MapEngine and wires up the EmbedHost
 * to receive postMessage commands from the parent SDK.
 *
 * Configuration is passed via URL query params (see EmbedHost).
 *
 * Also supports standalone usage (no parent iframe) for local
 * development and testing.
 */

const container = document.getElementById("map");
if (!container) throw new Error("Map container #map not found");

// Watermark
const watermark = document.createElement("a");
watermark.href = `${window.location.origin}/playground`;
watermark.target = "_blank";
watermark.textContent = "maps.trinit.is";
Object.assign(watermark.style, {
  position: "fixed",
  bottom: "6px",
  left: "8px",
  zIndex: "9999",
  fontSize: "10px",
  fontFamily: "system-ui, sans-serif",
  color: "rgba(255,255,255,0.25)",
  textDecoration: "none",
  pointerEvents: "auto",
  transition: "opacity 0.2s",
});
watermark.addEventListener("mouseenter", () => {
  watermark.style.color = "rgba(255,255,255,0.6)";
});
watermark.addEventListener("mouseleave", () => {
  watermark.style.color = "rgba(255,255,255,0.25)";
});
document.body.appendChild(watermark);

// Parse tile server URL from query params or default to relative path
const params = new URLSearchParams(window.location.search);
const tileUrl = params.get("tileUrl") || "/tiles/{z}/{x}/{y}.webp";

// Create the map engine with configurable overrides
const engine = new MapEngine(container, {
  tileUrl,
  // These can be overridden via additional query params in the future
  // worldSize, tilePx, minZoom, maxZoom, etc.
});

// Always set up the embed host - it parses URL config (data, focus, etc.)
// and in iframe mode also bridges postMessage commands from the parent SDK.
new EmbedHost(engine);
